import { styled } from "@mui/material/styles";
import {
  Typography,
  Autocomplete,
  autocompleteClasses,
  Popper
} from "@mui/material";

export const StyledAutocompletePopper = styled("div")(({ theme }) => ({
  order: 0,
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: "none",
    width: "auto",
    margin: 0,
    backgroundColor: "transparent"
  },
  [`& .${autocompleteClasses.listbox}`]: {
    padding: 0,
    maxHeight: "50vh",
    display: "grid",
    gap: theme.space._200,

    "@media (max-width: 600px)": {
      gap: 0,
    },

    [`& .${autocompleteClasses.option}`]: {
      padding: 0,
      alignItems: "flex-start",
      '&[aria-selected="true"]': {
        backgroundColor: "transparent",
      },
      [`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria-selected="true"]`]:
        {
          backgroundColor: "transparent",
        },
    },
  },
  [`&.${autocompleteClasses.popperDisablePortal}`]: {
    position: "relative",
  },
  [`&.${autocompleteClasses.noOptions}`]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  order: 1,
})) as typeof Autocomplete;

export const StyledPopper = styled(Popper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  boxShadow: theme.boxShadow["shadow.1"],
  borderRadius: "1rem",
  width: "20rem",
  zIndex: theme.zIndex.modal,
  marginTop: theme.space._300,

  fontSize: theme.fontSizes.sm,
  color: theme.colors["neutral.50"],
  backgroundColor: theme.colors["neutral.900"],
}));

export const ButtonContainer = styled("div")(({ theme }) => ({
  order: 1,
}));

export const OptionsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: `${theme.space._500} ${theme.space._450}`,
  gap: theme.space._400,
}));

export const TypographyPopper = styled(Typography)(({ theme }) => ({
  order: -1,

  color: theme.colors["neutral.50"],
  fontSize: theme.fontSizes.sm,
  fontFamily: theme.fonts.default,
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.base,
}));